import React, { Fragment } from 'react';
import LayoutPage from './components/LayoutPage/LayoutPage';
import AppRoutes from './routes';

const App = () => {
  return (
    <Fragment>
      <AppRoutes />
    </Fragment>
  );
};

export default App;
